module.exports = __webpack_public_path__ + "img/knowledgeTmp.714039e4.png";